define((require) => {
    "use strict";

    const AbstractProjectAttachView           = require("ui/projects/AbstractProjectAttachView");
    const ChannelCollection                   = require("data/ChannelCollection");
    const PublishOptionsProvider              = require("editor/ui/experience/editor/PublishOptionsProvider");
    const ProjectAttachChannelSetupManualView = require("ui/projects/publish/ProjectAttachChannelSetupManualView");
    const Promise                             = require("shared/util/Promise");

    /**
     * Subclass of AbstractProjectAttachView representing the attach view in a project context. <p>
     *
     * @class ProjectAttachChannelCollectionView
     * @see AbstractProjectAttachView
     */
    return AbstractProjectAttachView.extend("ProjectAttachChannelCollectionView", {

        className: AbstractProjectAttachView.prototype.className + " channels",

        collectionView: ProjectAttachChannelSetupManualView,

        collectionOptions() {
            return Promise.all([ChannelCollection.count(), PublishOptionsProvider.provide({maxScenes: 0})])
                .then((results) => {
                    return {
                        header: {
                            label: "All Channels",
                            count: results[0]
                        },
                        collection: results[1].channelCollection
                    };
                });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/publish/ProjectAttachChannelCollectionView.js